import OwlCarousel from "react-owl-carousel";
import Footer from "../footer";
import Header from "../header";
import LocationService from "../../../../services/locationService";
import AppController from "../../../controller/appController";
import Spinner from "../../../common/spinner";
import { Progress, Spin, Tooltip } from "antd";
import RequestCallback from "../requestCallback";
import FullPopup from "../fullPopup";
import Loader from "../guestPortal/loader";
import { withRouter } from "react-router-dom";
import {
  calculateBookingPrices,
  stayCalulation,
  totalFullStayAmount,
  calculateTempInvoice,
  mergeInvoicesByDaysLimit,
} from "./bookingCalculations";
import { data } from "jquery";
// import schoolData from "./greatSchoolsData.json";
class LocationPropertyDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      latitude: 0.0,
      longitude: 0.0,
      appartmentAmenities: [],
      appartmentamenitieslist: [],
      communityAmenities: [],
      communityImages: [],
      communityALLImages: [],
      communityObject: {},
      showlist: false,
      showSearch: false,
      directionsService: {},
      directionsDisplay: {},
      destinationAdd: "",
      location: [],
      markerList: [],
      greatSchools: {},
      allScools: [],
      PageLoader: false,
      imgloader: true,
      types: [
        {
          name: "Restaurants",
          type: "restaurant",
          fa: "fas fa fa-cutlery",
          icon: "/assets/newUI-images/explore_icons/restarent.svg",
        },
        {
          name: "Bars",
          type: "bar",
          fa: "fas fa fa-beer",
          icon: "/assets/newUI-images/explore_icons/bars.svg",
        },
        {
          name: "Groceries",
          type: "supermarket",
          fa: "fas fa fa-shopping-cart",
          icon: "/assets/newUI-images/explore_icons/groceries.svg",
        },
        {
          name: "Park",
          type: "park",
          fa: "fas fa fa-tree",
          icon: "/assets/newUI-images/explore_icons/parks.svg",
        },
        {
          name: "Shopping",
          type: "shopping_mall",
          fa: "fas fa fa-shopping-bag",
          icon: "/assets/newUI-images/explore_icons/shopping.svg",
        },
        {
          name: "Entertainment",
          type: "night_club",
          fa: "fas fa fa-film",
          icon: "/assets/newUI-images/explore_icons/entertainment.svg",
        },
      ],
      type: "",
      typeicon: 0,
      placeSearchedMarkers: [],
      activeNumber: -1,
      walkscore: null,
      transitscore: null,
      bikescore: null,
      privateScools: [],
      publicScools: [],
      charterScools: [],
      fullpopdata: {},
      checkin: "",
      checkout: "",
      errorMessage: "",
      utilities: 0,
      housewares: 0,
      serviceFee: 0,
      totalAmount: "",
      cleaning: 0,
      monthlyRent: "",
      rent: "",
      showTotalStay: false,
      buttonLoader: false,
      totalStayAmount: "",
      fullStayAmount: "",
      invoiceList: [],
      newInvoiceList: [],
      totalStayDays: 0,
    };
    this.typeView = this.typeView.bind(this);
    this.methodx = this.methodx.bind(this);
    this.destinationLocation = this.destinationLocation.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.resetData = this.resetData.bind(this);
    this.onetype = this.onetype.bind(this);
    this.flyToPlace = this.flyToPlace.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleOpenCarousel = this.handleOpenCarousel.bind(this);
    this.handleclose = this.handleclose.bind(this);
    this.handleClick2 = this.handleClick2.bind(this);
  }

  handleError(error) {
    console.log(error.message, "error.message");
  }

  async handleClick2() {
    // $("#sideQuote").addClass("active");
    // $(".overlay").addClass("active");
    // $(".collapse.in").toggleClass("in");
    // $("a[aria-expanded=true]").attr("aria-expanded", "false");
    // window.open("/instant-reserve-book", );
    this.setState({ buttonLoader: true });
    let requestObject = {
      master_id: this.state.communityObject.MasterId,
      checkin: this.state.checkin,
      checkout: this.state.checkout,
    };
    // console.log(requestObject, "requestObject");

    let response = await LocationService.checkMasterAvailability(requestObject);

    if (response.error == "0") {
      this.setState({ buttonLoader: false });
      this.props.history.push("/instant-reserve-book");
    } else {
      this.setState({ buttonLoader: false, errorMessage: response.message });
    }
  }

  flyToPlace(row, index, type) {
    var latLng = new google.maps.LatLng(row.latitude, row.longitude);
    this.map.panTo(latLng);
    const placemarker =
      type == "locations"
        ? this.state.markerList
        : this.state.placeSearchedMarkers;
    google.maps.event.trigger(placemarker[index], "click");
    this.setState({ activeNumber: row.name });
  }

  async componentDidMount() {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href =
      "https://suiteam-website.s3.us-west-1.amazonaws.com/new/logo/SA-Icon.png";
    await this.getDetails();
    await this.getCheckInCheckOut();
    await this.methodx();
  }

  async getCheckInCheckOut() {
    const savedState = localStorage.getItem("reserveState");
    let normalObject = JSON.parse(savedState);
    if (normalObject) {
      this.setState({
        checkin: normalObject.checkin,
        checkout: normalObject.checkout,
        monthlyRent: normalObject.monthlyRent,
        rent: normalObject.monthlyRent,
      });
    }
  }

  async getDetails() {
    try {
      const communitydetails = await JSON.parse(
        localStorage.getItem("moreData")
      );

      let paramsUrl = this.props.match.params.masterId.split("-");

      let selectedMasterId = paramsUrl[paramsUrl.length - 1];
      let selectedCommunityName = this.props.match.params.masterId.replace(
        "-" + selectedMasterId,
        ""
      );

      var propsCommunity =
        selectedCommunityName == "BOULEVARD-APARTMENTS-FREMONT"
          ? "BOULEVARD APARTMENTS-FREMONT"
          : selectedCommunityName == "THE-CARLYLE-SANTA-CLARA"
          ? "THE CARLYLE-SANTA CLARA"
          : selectedCommunityName == "PARK-CENTRAL-CONCORD"
          ? "PARK CENTRAL/CONCORD"
          : selectedCommunityName == "THE-COVE-TIBURON"
          ? "THE COVE/TIBURON"
          : selectedCommunityName == "WATERFORD-PLACE-DUBLIN"
          ? "WATERFORD PLACE/DUBLIN"
          : selectedCommunityName.replace(new RegExp("-", "gi"), " ");
      var communityName = propsCommunity;
      const limitData = {
        communityName: encodeURIComponent(encodeURIComponent(communityName)),
        imageType: "banner",
        masterid: selectedMasterId,
      };
      const details = await LocationService.GetCommunityInfoByNameInfo(
        limitData
      );
      await this.setState({ communityObject: details.complexInfo });
      //this.getNearCommunitysByCommunity()
      const appartmentAmenities =
        this.state.communityObject.AmenitiesList != null &&
        this.state.communityObject.AmenitiesList != undefined
          ? JSON.parse(this.state.communityObject.AmenitiesList)
          : [];
      let communityImages =
        this.state.communityObject.CommunityImages != null &&
        this.state.communityObject.CommunityImages != undefined
          ? JSON.parse(this.state.communityObject.CommunityImages)
          : [];
      if (
        this.state.communityObject.CommunityImages != null &&
        this.state.communityObject.CommunityImages != undefined
      ) {
        communityImages.unshift({
          image_name: this.state.communityObject.image_name,
        });
      }
      const communityGroupImages =
        communityImages.length > 0
          ? _.groupBy(communityImages, "imageType")
          : "";

      const complexImages =
        communityImages != null
          ? communityGroupImages.complex != undefined
            ? communityGroupImages.complex
            : communityGroupImages.interior
          : [];
      const apparmentamenites =
        appartmentAmenities != null && appartmentAmenities != undefined
          ? _.filter(appartmentAmenities, function (o) {
              return o.communityname == "Unit";
            })
          : [];
      const communityamenites =
        appartmentAmenities != null && appartmentAmenities != undefined
          ? _.filter(appartmentAmenities, function (o) {
              return o.communityname == "Community";
            })
          : [];
      await this.walkScoreInfo(details.complexInfo);

      // let result = appartmentAmenities.map((a) =>
      //   console.log(
      //     a.aparment_amenity_name.replace(/[^A-Z0-9]+/gi, ""),
      //     "--appartmentAmenities"
      //   )
      // );
      await this.setState({
        latitude: this.state.communityObject.latitude,
        longitude: this.state.communityObject.longitude,
        appartmentAmenities: apparmentamenites,
        appartmentamenitieslist: appartmentAmenities,
        communityAmenities: communityamenites,
        communityImages: complexImages,
        communityALLImages: communityImages,
      });
      await this.setState({ PageLoader: true });
    } catch (error) {
      this.handleError(error);
    }
  }

  async walkScoreInfo(communityData) {
    const results = await AppController.wallsckoreFuns(communityData);
    if (results != undefined && results != null && results != 0) {
      this.setState({
        walkscore: results.walkscore,
        bikescore: results.bike.score,
        transitscore: results.transit == null ? null : results.transit.score,
      });
    }
    const greatSchools = await AppController.greatSchools2(communityData);

    // let greatSchools = schoolData;

    const privateScools = _.filter(greatSchools.schools, function (o) {
      o.schoolSummary = o["school-summary"];
      o.overviewUrl = o["overview-url"];
      return o.type == "private";
    });
    const publicScools = _.filter(greatSchools.schools, function (o) {
      o.schoolSummary = o["school-summary"];
      o.overviewUrl = o["overview-url"];
      return o.type == "public";
    });
    const charterScools = _.filter(greatSchools.schools, function (o) {
      o.schoolSummary = o["school-summary"];
      o.overviewUrl = o["overview-url"];
      return o.type == "charter";
    });
    this.setState({
      allScools: publicScools,
      greatSchools: greatSchools,
      privateScools: privateScools,
      publicScools: publicScools,
      charterScools: charterScools,
    });
  }

  async typeView() {
    $(".nav-link").removeClass("active");
    $("#name").addClass("active");
    this.setState({
      showlist: false,
      showSearch: false,
    });
    this.methodx();
  }

  async resetData() {
    this.methodx();
  }

  searchPlace() {
    this.setState({
      showSearch: true,
      showlist: true,
    });
  }

  async methodx() {
    await this.setState({
      directionsService: {},
      directionsDisplay: {},
      destinationAdd: "",
    });
    document.getElementById("dvDistance").innerHTML = "";
    $("#txtPlaces").val("");
    if ($("#map" + this.state.communityObject.community_id).length) {
      var locations = {
        lat: Number(this.state.communityObject.latitude),
        lng: Number(this.state.communityObject.longitude),
      };
      const map = new google.maps.Map(
        document.getElementById(
          "map" + this.state.communityObject.community_id
        ),
        {
          zoom: 7,
          center: locations,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          backgroundColor: "#eeeeee",
          disableDefaultUI: true,
        }
      );
      var style = [
        {
          elementType: "geometry",
          stylers: [{ saturation: -40 }],
        },
      ];
      var mapType = new google.maps.StyledMapType(style, { name: "Grayscale" });
      map.mapTypes.set("grey", mapType);
      map.setMapTypeId("grey");
      var customZoomInControlDiv = document.createElement("div");
      this.CustomZoomInControl(customZoomInControlDiv, map);
      customZoomInControlDiv.index = 1;
      map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
        customZoomInControlDiv
      );
      await this.setState({ customMap: map });

      // MapController.customMarkers(this.state.communityObject, 'singlemark', this, '', s3BucketUrl_WebsiteImages + 'SuiteAmerica-M' +
      //   'ap-Marker-Red.png',
      //   customMap);

      var directionsService = new google.maps.DirectionsService();
      var directionsDisplay = new google.maps.DirectionsRenderer();
      this.setState({ directionsService: directionsService });
      this.setState({ directionsDisplay: directionsDisplay });
      const image_name = this.state.communityObject.image_name;
      const communityName = this.state.communityObject.community_name;
      const communityAddress = this.state.communityObject.address;
      const communityLat = this.state.communityObject.latitude;
      const communityLong = this.state.communityObject.longitude;
      const communityCity = this.state.communityObject.city_name;
      const communityState = this.state.communityObject.state_name;
      const communityZipcode = this.state.communityObject.ZipCode;
      const detailAddress =
        communityAddress +
        ", " +
        communityCity +
        ", " +
        communityState +
        " " +
        communityZipcode;
      var locations = {
        lat: Number(communityLat),
        lng: Number(communityLong),
      };
      var contentString =
        '<div id="content">' +
        '<div id="siteNotice">' +
        "</div>" +
        '<div id="bodyContent">' +
        '<div class="bodycontentimg"><img width="100px" height="100px" src="' +
        image_name +
        '" /> </div>' +
        "<h1>" +
        communityName +
        "</h1>" +
        "<p>" +
        detailAddress +
        ' </p><a href="https://www.google.com/maps?daddr=' +
        communityLat +
        "," +
        communityLong +
        '" target="_blank">Get driving directions</a>' +
        "</div>" +
        "</div>";
      this.state.directionsDisplay.setMap(this.state.customMap);
      var infowindow = new google.maps.InfoWindow({
        content: contentString,
      });
      var marker = new google.maps.Marker({
        position: locations,
        icon: "/assets/newUI-images/explore_icons/map_icon.svg",
        // icon: icon,
        map: map,
      });
      marker.addListener("click", function () {
        infowindow.open(map, marker);
      });
    }
  }

  CustomZoomInControl(controlDiv, map) {
    // Set CSS for the control border
    var controlUI = document.createElement("div");

    controlUI.style.cursor = "pointer";
    controlUI.style.display = "-webkit-inline-box";
    controlUI.style.margin = "18px 10px";
    controlUI.style.width = "30px";
    controlUI.style.height = "30px";
    controlDiv.appendChild(controlUI);
    // Set CSS for the control interior
    var controlText = document.createElement("div");
    controlText.innerHTML += `<img style="height:30px;width:30px;margin:0"  src='/assets/newUI-images/plus.svg' />`;
    controlUI.appendChild(controlText);

    // Setup the click event listeners
    google.maps.event.addDomListener(controlUI, "click", function () {
      map.setZoom(map.getZoom() + 1);
    });

    // Set CSS for the control border
    var controlUILeft = document.createElement("div");

    controlUILeft.style.display = "-webkit-inline-box";
    controlUILeft.style.marginLeft = "10px";
    controlUILeft.style.cursor = "pointer";
    controlUILeft.style.width = "30px";
    controlUILeft.style.height = "30px";
    controlDiv.appendChild(controlUILeft);

    var controlTextLeft = document.createElement("div");

    controlTextLeft.innerHTML += `<img style="height:30px;width:30px;margin:0"  src='/assets/newUI-images/minus.svg' />`;
    controlUILeft.appendChild(controlTextLeft);

    // Setup the click event listeners
    google.maps.event.addDomListener(controlUILeft, "click", function () {
      map.setZoom(map.getZoom() - 1);
    });
  }

  destinationLocation() {
    var address = "";
    const _this = this;
    var places = new google.maps.places.Autocomplete(
      document.getElementById("txtPlaces")
    );
    google.maps.event.addListener(places, "place_changed", function () {
      var place = places.getPlace();
      address = place.formatted_address;
      _this.setState({ destinationAdd: address });
    });
  }

  async handleFormSubmit() {
    if (!this.state.destinationAdd) {
      return;
    }
    var gmarkers = [];
    const _this = this;
    await _this.searchPlace();
    var locations = {
      lat: Number(this.state.communityObject.latitude),
      lng: Number(this.state.communityObject.longitude),
    };

    const customMap = new google.maps.Map(
      document.getElementById("map" + this.state.communityObject.community_id),
      {
        zoom: 7,
        center: locations,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        backgroundColor: "#eeeeee",
        disableDefaultUI: true,
        clickableIcons: false,
      }
    );
    var style = [
      {
        elementType: "geometry",
        stylers: [
          { saturation: -40, visibility: "off", clickableIcons: false },
        ],
      },
    ];
    var mapType = new google.maps.StyledMapType(style, { name: "Grayscale" });
    customMap.mapTypes.set("grey", mapType);
    customMap.setMapTypeId("grey");
    var customZoomInControlDiv = document.createElement("div");
    this.CustomZoomInControl(customZoomInControlDiv, customMap);
    customZoomInControlDiv.index = 1;
    customMap.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
      customZoomInControlDiv
    );
    await this.setState({ customMap });

    var directionsService = new google.maps.DirectionsService();
    var directionsDisplay = new google.maps.DirectionsRenderer();

    const image_name = this.state.communityObject.image_name;
    const communityName = this.state.communityObject.community_name;
    const communityAddress = this.state.communityObject.address;
    const communityLat = this.state.communityObject.latitude;
    const communityLong = this.state.communityObject.longitude;
    const communityCity = this.state.communityObject.city_name;
    const communityState = this.state.communityObject.state_name;
    const communityZipcode = this.state.communityObject.ZipCode;
    const detailAddress =
      communityAddress +
      ", " +
      communityCity +
      ", " +
      communityState +
      " " +
      communityZipcode;
    var locations = {
      lat: Number(communityLat),
      lng: Number(communityLong),
    };

    const community_lat = this.state.communityObject.latitude;
    const community_long = this.state.communityObject.longitude;
    var request = {
      origin: { lat: Number(community_lat), lng: Number(community_long) },
      destination: this.state.destinationAdd,

      travelMode: google.maps.DirectionsTravelMode.DRIVING,
    };

    directionsService.route(request, function (response, status) {
      if (status == google.maps.DirectionsStatus.OK) {
        new google.maps.DirectionsRenderer({
          map: _this.state.customMap,
          directions: response,
          suppressMarkers: true,
        });

        var distance = response.routes[0].legs[0].distance.text;
        var duration = response.routes[0].legs[0].duration.text;
        var dvDistance = document.getElementById("dvDistance");
        dvDistance.innerHTML = "";
        dvDistance.innerHTML += "<h4>Your Commute Summary</h4>";
        dvDistance.innerHTML += "<p>Drive Time: " + duration + "</p>";
        dvDistance.innerHTML += "<p>Distance: " + distance + "</p>";

        function makeMarker(position, icon, title, map) {
          let mark = new google.maps.Marker({
            position: position,
            map: map,
            icon: icon,
            title: title,
            disableDefaultUI: true,
            styles: style,
          });
        }
        var icons = {
          start: new google.maps.MarkerImage(
            "/assets/newUI-images/explore_icons/map_icon.svg"
          ),
          end: new google.maps.MarkerImage(
            "https://suiteam-website.s3.us-west-1.amazonaws.com/new/icons/location_pin_2.svg"
          ),
        };

        var leg = response.routes[0].legs[0];
        makeMarker(
          leg.start_location,
          icons.start,
          "title",
          _this.state.customMap
        );
        makeMarker(leg.end_location, icons.end, "title", _this.state.customMap);
      }
    });
  }

  async onetype(row, type) {
    $(".nav-link").removeClass("active");
    $("#" + row.name).addClass("active");
    await this.setState({
      type: row.type,
      showlist: true,
      typeName: row.name,
      typeicon: type,
      showSearch: false,
    });
    this.loadPlacesWithMarkers(1, this.state.typeicon);
  }

  async loadPlacesWithMarkers(index) {
    const _this = this;
    const markers = [];
    var pyrmont = {
      lat: Number(this.state.latitude),
      lng: Number(this.state.longitude),
    };
    console.log(pyrmont, "pyrmont");
    const map = (this.map = new google.maps.Map(
      document.getElementById("map" + this.state.communityObject.community_id),
      {
        zoom: 14,
        center: pyrmont,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        backgroundColor: "#eeeeee",
        disableDefaultUI: true,
      }
    ));
    var style = [
      {
        elementType: "geometry",
        stylers: [{ saturation: -40 }],
      },
    ];
    var mapType = new google.maps.StyledMapType(style, { name: "Grayscale" });
    map.mapTypes.set("grey", mapType);
    map.setMapTypeId("grey");
    var customZoomInControlDiv = document.createElement("div");
    this.CustomZoomInControl(customZoomInControlDiv, map);
    customZoomInControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
      customZoomInControlDiv
    );

    const propertyMarker = new google.maps.Marker({
      map: map,
      position: pyrmont, // Using the same location as center
      icon: "/assets/newUI-images/explore_icons/map_icon.svg",
      zIndex: 999, // Keep property marker on top
    });

    // Add info window for property
    const propertyInfoWindow = new google.maps.InfoWindow();
    const propertyContent =
      '<div id="content">' +
      '<div id="siteNotice">' +
      "</div>" +
      '<div id="bodyContent">' +
      '<div class="bodycontentimg"><img width="100px" height="100px" src="' +
      this.state.communityObject.image_name +
      '" /> </div>' +
      "<h1>" +
      this.state.communityObject.community_name +
      "</h1>" +
      "<p>" +
      this.state.communityObject.address +
      ' </p><a href="https://www.google.com/maps?daddr=' +
      this.state.communityObject.latitude +
      "," +
      this.state.communityObject.longitude +
      '" target="_blank">Get driving directions</a>' +
      "</div>" +
      "</div>";

    google.maps.event.addListener(propertyMarker, "click", function () {
      propertyInfoWindow.setContent(propertyContent);
      propertyInfoWindow.open(map, propertyMarker);
    });

    // Store property marker
    this.setState({
      propertyMarker: propertyMarker,
    });

    var service = new google.maps.places.PlacesService(map);
    const request = {
      location: pyrmont,
      radius: 2000,
      type: this.state.type,
    };

    service.nearbySearch(request, async (data, status) => {
      var infowindow = new google.maps.InfoWindow();
      if ("OK" === google.maps.places.PlacesServiceStatus.OK) {
        const location = [];
        var results = _.orderBy(data, ["name"], ["asc"]);
        for (var i = 0; i < results.length; i++) {
          location.push({
            latitude: results[i].geometry.location.lat(),
            longitude: results[i].geometry.location.lng(),
            name: results[i].name,
            address: results[i].vicinity,
          });
          const marker = (this.marker = new google.maps.Marker({
            map: map,
            position: results[i].geometry.location,
            center: results[i].geometry.location,
            icon: this.state.types[this.state.typeicon].icon,
          }));
          google.maps.event.addListener(
            marker,
            "click",
            (function (markerd, ii) {
              return function () {
                var contentString = "";
                var prop = "photos";
                if (results[ii].hasOwnProperty(prop)) {
                  _this.setState({ activeNumber: results[ii].name });
                  contentString =
                    '<h3 style="font-size:20px; text-align:center">' +
                    results[ii].name +
                    '</h3><img src="' +
                    results[ii].photos[0].getUrl() +
                    '" alt="Loading" width="160" height="80"> <div id="content"><div className=""><div></div><p>' +
                    results[ii].vicinity +
                    '</p> <a href="' +
                    "https://www.google.com/maps/place/" +
                    results[ii].vicinity +
                    '" target="_blank">Get Directions</a></div>' +
                    "</div>";
                } else {
                  _this.setState({ activeNumber: results[ii].name });
                  contentString =
                    '<h3 style="font-size:20px; text-align:center">' +
                    results[ii].name +
                    '</h3> <div id="content"><div className=""><div></div><p>' +
                    results[ii].vicinity +
                    '</p> <a href="' +
                    "https://www.google.com/maps/place/" +
                    results[ii].vicinity +
                    '" target="_blank">Get Directions</a></div>' +
                    "</div>";
                }
                infowindow.setContent(contentString);
                infowindow.open(map, this);
              };
            })(marker, i)
          );
          markers.push(marker);
        }
        console.log(location, "location", markers);

        await _this.setState({
          location: location,
          markerList: markers,
        });
        _this.getDistance();
      }
    });
    _this.setState({
      map,
    });
    // await MapController.customMarkers(this.state.communityObject, 'singlemark', this, '', s3BucketUrl_WebsiteImages + 'SuiteAmerica-M' + 'ap-Marker-Red.png', map);
    // await this.methodx();
  }

  async getDistance() {
    for (var i = 0; i < this.state.location.length; i++) {
      if (
        this.state.location[i].latitude != "" &&
        this.state.location[i].latitude != undefined &&
        this.state.location[i].latitude != null &&
        this.state.location[i].longitude != "" &&
        this.state.location[i].longitude != undefined &&
        this.state.location[i].longitude != null
      ) {
        const distanceVal = this.distanceCal(
          this.state.latitude,
          this.state.longitude,
          this.state.location[i].latitude,
          this.state.location[i].longitude
        );
        let updatedPosts = update(this.state.location, {
          [i]: {
            distance: {
              $set: parseFloat(distanceVal),
            },
          },
        });
        await this.setState({
          location: updatedPosts,
        });
      } else {
        let updatedPosts = update(this.state.location, {
          [i]: {
            distance: {
              $set: 0,
            },
          },
        });
        await this.setState({
          location: updatedPosts,
        });
      }
      if (this.state.location.length == i + 1) {
        await this.setState({
          location: _.sortBy(this.state.location, [
            function (o) {
              return o.distance;
            },
          ]),
        });
      }
    }
  }

  distanceCal(lat1, lon1, lat2, lon2, unit) {
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == "K") {
      dist = dist * 1.609344;
    }
    if (unit == "N") {
      dist = dist * 0.8684;
    }
    return dist.toFixed(2);
  }

  async handleClick(type) {
    $(".nav-item").removeClass("active");
    $("#" + type).addClass("active");
    var data = [];
    if (type == "private") {
      data = this.state.privateScools;
    } else if (type == "public") {
      data = this.state.publicScools;
    } else if (type == "charter") {
      data = this.state.charterScools;
    }
    await this.setState({
      allScools: data,
    });
  }

  async handleOpenCarousel(row) {
    console.log(row);
    await this.setState({ fullpopdata: row });
    jQuery(
      function ($) {
        setTimeout(
          function () {
            $("#fullmodel-Carousel1").modal("show");
          }.bind(this),
          500
        );
      }.bind(this)
    );
    // this.setState({ imgloader: false })
    // $('document').ready(function () {
    //   $('#smallmodel-Carousel1').modal('show');
    // });
    // jQuery(function ($) {
    //   setTimeout(function () {
    //     this.setState({ imgloader: true })
    //   }.bind(this), 500);
    // }.bind(this));
  }

  async handleclose() {
    $("document").ready(function () {
      $("#smallmodel-Carousel1").modal("hide");
    });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      this.state.communityObject !== prevState.communityObject ||
      this.state.rent !== prevState.rent
    ) {
      const { utilities, cleaning, housewares, serviceFee, totalAmount } =
        calculateBookingPrices(
          this.state.communityObject.SuiteSizeCode,
          this.state.rent
        );
      // console.log({ utilities, cleaning, housewares, serviceFee, totalAmount });

      this.setState({
        utilities: utilities,
        housewares: housewares,
        serviceFee: serviceFee,
        totalAmount: totalAmount,
        cleaning: cleaning,
      });

      const { totalAmountLimit, totalAmountFull, stayDays } =
        totalFullStayAmount(
          this.state,
          utilities,
          housewares,
          serviceFee,
          cleaning
        );

      if (totalAmountLimit !== undefined && totalAmountFull !== undefined) {
        const response = await calculateTempInvoice(this.state, totalAmount);
        // console.log(response, "response");
        if (Array.isArray(response) && response.length > 0) {
          let mergingData = await mergeInvoicesByDaysLimit(response);
          // console.log(mergingData, "mergingData");
          this.setState({
            newInvoiceList: mergingData,
          });
        }

        this.setState({
          totalStayAmount: totalAmountLimit.toFixed(2),
          fullStayAmount: totalAmountFull.toFixed(2),
          invoiceList: response,
          totalStayDays: stayDays,
          // newInvoiceList: mergingData,
        });
      }
    }
  }

  async totalStayCalculation() {
    const { showTotalStay } = this.state;
    console.log(showTotalStay, "showTotalStay");

    if (!showTotalStay) {
      const {
        stayUtilitiesFee,
        stayHousewaresFee,
        stayServiceFee,
        totalStayAmount,
        totalAmount,
      } = stayCalulation(this.state);

      this.setState({
        utilities: stayUtilitiesFee.toFixed(2),
        housewares: stayHousewaresFee.toFixed(2),
        serviceFee: stayServiceFee.toFixed(2),
        monthlyRent: totalStayAmount.toFixed(2),
        totalAmount: totalAmount.toFixed(2),
        showTotalStay: true,
      });
    }
  }

  async monthlyCalculation() {
    const { rent, utilities, cleaning, housewares, serviceFee, totalAmount } =
      calculateBookingPrices(
        this.state.communityObject.SuiteSizeCode,
        this.state.rent
      );

    this.setState({
      utilities,
      cleaning,
      housewares,
      serviceFee,
      totalAmount,
      showTotalStay: false,
      monthlyRent: rent,
    });
  }

  render() {
    const communityALLImages = this.state.communityALLImages;
    const urlArray = [];
    let arrow =
      Object.keys(this.state.communityObject).length > 0
        ? communityALLImages.map((galleyImage, galleyImageIndex) => {
            if (galleyImage.image_name != null) {
              urlArray.push({
                original: galleyImage.image_name,
                thumbnail: galleyImage.image_name,
              });
            }
          })
        : "";
    let filterIMages = _.uniqBy(urlArray, "original");
    var finalLocation = _.orderBy(this.state.location, ["name"], ["asc"]);

    return (
      <div className="SAweb_updateUi">
        <Header />
        {!this.state.PageLoader ? (
          <Loader />
        ) : (
          <div>
            <section className="bg-white py-5  sa-community-details">
              <div className="container">
                {communityALLImages.length > 0 ? (
                  <div
                    className={
                      communityALLImages.length > 2
                        ? "imageView mb-3 "
                        : "imageView mb-3 oneImage"
                    }
                  >
                    <div className="items">
                      <img src={communityALLImages[0].image_name} alt="" />
                      {/* <button className="btn" type="button"> 3D Tour </button> */}
                    </div>
                    <div className="image-gallery ">
                      <div className="item">
                        <img src={communityALLImages[1].image_name} alt="" />
                      </div>
                      <div className="item">
                        {communityALLImages.length > 2 ? (
                          <>
                            <img
                              src={communityALLImages[2].image_name}
                              alt=""
                            />
                            <button
                              className="btn photos"
                              onClick={() =>
                                this.handleOpenCarousel(
                                  this.state.communityObject
                                )
                              }
                              type="button"
                            >
                              {
                                communityALLImages.slice(
                                  2,
                                  communityALLImages.length
                                ).length
                              }{" "}
                              More Photos
                            </button>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="subHeading py-4">
                  <div className="row">
                    <div className="col-md-8">
                      {Object.keys(this.state.communityObject).length > 0 ? (
                        <div>
                          <h2 className="text-left">
                            {this.state.communityObject.community_name !=
                            undefined
                              ? this.state.communityObject.community_name
                              : ""}
                          </h2>
                          <p>
                            {this.state.communityObject.address != undefined
                              ? this.state.communityObject.address
                              : ""}
                            ,{" "}
                            {this.state.communityObject.city_name != undefined
                              ? this.state.communityObject.city_name
                                  .toLowerCase()
                                  .split(" ")
                                  .map(
                                    (s) =>
                                      s.charAt(0).toUpperCase() + s.substring(1)
                                  )
                                  .join(" ")
                              : ""}
                            ,{" "}
                            {this.state.communityObject.state_name != undefined
                              ? this.state.communityObject.state_name
                                  .toLowerCase()
                                  .split(" ")
                                  .map(
                                    (s) =>
                                      s.charAt(0).toUpperCase() + s.substring(1)
                                  )
                                  .join(" ")
                              : ""}{" "}
                            {this.state.communityObject.ZipCode != undefined
                              ? this.state.communityObject.ZipCode
                              : ""}
                          </p>
                        </div>
                      ) : null}
                      <ul className="a-list">
                        <li>
                          {" "}
                          <img
                            src="/assets/newUI-images/communityView/single-bed.svg"
                            alt=""
                          />{" "}
                          <span>{this.state.communityObject.bedrooms}</span>{" "}
                          Bedroom{" "}
                        </li>
                        <li>
                          {" "}
                          <img
                            src="/assets/newUI-images/communityView/tub.svg"
                            alt=""
                          />{" "}
                          <span>{this.state.communityObject.bathrooms}</span>{" "}
                          Bathroom{" "}
                        </li>
                      </ul>
                      <hr />

                      <h4>SuiteAmerica Standard</h4>

                      <ul className="gap-2 justify-content-between ssView">
                        <li>
                          <div className="image">
                            <img
                              src="/assets/newUI-images/communityView/sofa.png"
                              alt=""
                              width={"50"}
                              className="d-block m-auto pb-2"
                            />
                          </div>
                          Fully-Furnished
                        </li>
                        <li>
                          <div className="image">
                            <img
                              src="/assets/newUI-images/communityView/clean-linen-basket.png"
                              alt=""
                              width={"40"}
                              className="d-block m-auto pb-2"
                            />
                          </div>
                          Fresh Linens & Towels
                        </li>
                        <li>
                          <div className="image">
                            <img
                              src="/assets/newUI-images/communityView/settings.png"
                              alt=""
                              width={"45"}
                              className="d-block m-auto pb-2"
                            />
                          </div>
                          Utilities Included
                        </li>
                        <li>
                          <div className="image">
                            <img
                              src="/assets/newUI-images/communityView/wifi-router.png"
                              alt=""
                              width={"45"}
                              className="d-block m-auto pb-2"
                            />
                          </div>
                          High-speed Wi-Fi
                        </li>
                        <li>
                          <div className="image">
                            <img
                              src="/assets/newUI-images/communityView/online-support.png"
                              alt=""
                              width={"45"}
                              className="d-block m-auto pb-2"
                            />
                          </div>
                          24X7 Support
                        </li>
                      </ul>
                      <hr />

                      <h4>Property Amenities</h4>
                      {this.state.PageLoader ? (
                        this.state.communityAmenities.length > 0 ? (
                          // <div className="box box_second">
                          <ul className="amenities">
                            {this.state.communityAmenities
                              .sort((a, b) =>
                                a.aparment_amenity_name.localeCompare(
                                  b.aparment_amenity_name
                                )
                              )
                              .slice(0, 4)
                              .map((row, index) => {
                                return (
                                  <li className="item" key={index}>
                                    <img
                                      width="55"
                                      src={
                                        s3BucketUrl +
                                        "Amenities/" +
                                        row.aparment_amenity_name.replace(
                                          /[^A-Z0-9]+/gi,
                                          ""
                                        ) +
                                        ".png"
                                      }
                                    />
                                    <span>{row.aparment_amenity_name}</span>
                                  </li>
                                );
                              })}
                          </ul>
                        ) : (
                          // </div>
                          <div
                            className="text-center"
                            style={{
                              fontSize: "15px",
                              width: "100%",
                              margin: "auto",
                              textAlign: "center",
                            }}
                          >
                            No Property Amenities Found
                          </div>
                        )
                      ) : (
                        ""
                      )}

                      <hr />

                      <h4>In-Unit Amenities</h4>

                      {this.state.PageLoader ? (
                        this.state.appartmentAmenities.length > 0 ? (
                          <div className="box box_second">
                            <ul className="amenities">
                              {this.state.appartmentAmenities
                                .sort((a, b) =>
                                  a.aparment_amenity_name.localeCompare(
                                    b.aparment_amenity_name
                                  )
                                )
                                .slice(0, 4)
                                .map((row, index) => {
                                  return (
                                    <li className="item" key={index}>
                                      <img
                                        width="55"
                                        src={
                                          s3BucketUrl +
                                          "Amenities/" +
                                          row.aparment_amenity_name.replace(
                                            /[^A-Z0-9]+/gi,
                                            ""
                                          ) +
                                          ".png"
                                        }
                                      />
                                      <span>{row.aparment_amenity_name}</span>
                                    </li>
                                  );
                                })}
                            </ul>
                          </div>
                        ) : (
                          <div
                            className="text-center"
                            style={{
                              fontSize: "15px",
                              width: "100%",
                              margin: "auto",
                              textAlign: "center",
                            }}
                          >
                            No In-Unit Amenities Found
                          </div>
                        )
                      ) : (
                        ""
                      )}

                      {this.state.appartmentAmenities.length > 4 ? (
                        <button
                          type="button"
                          className="btn black-btn mt-5"
                          data-toggle="modal"
                          data-target="#staticBackdrop"
                        >
                          {/* <i className="bi bi-plus"></i> */}
                          View all amenities
                        </button>
                      ) : (
                        ""
                      )}

                      <hr />
                      <h4>House Guidelines</h4>

                      <ul className="guidelines">
                        <li>
                          {" "}
                          <img
                            src="/assets/newUI-images/communityView/clock.png"
                            alt=""
                          />{" "}
                          Arrival & Departure
                          <ul>
                            <li>
                              Check-in anytime after 11:00 AM and Check out by
                              3:00 PM on departure day
                            </li>
                          </ul>
                        </li>
                        <li>
                          {" "}
                          <img
                            src="/assets/newUI-images/communityView/no-smoking.png"
                            alt=""
                          />{" "}
                          No smoking
                          <ul>
                            <li>
                              This is a non-smoking property. Smoking is not
                              permitted indoors or in shared community areas.
                            </li>
                          </ul>
                        </li>
                        <li>
                          {" "}
                          <img
                            src="/assets/newUI-images/communityView/party.png"
                            alt=""
                          />{" "}
                          Quiet Enjoyment
                          <ul>
                            <li>
                              Out of respect for neighbors and the community,
                              events, parties, and large gatherings are not
                              allowed.
                            </li>
                          </ul>
                        </li>
                      </ul>
                      <hr />

                      <h4>
                        <img
                          width={25}
                          className="me-3"
                          src="/assets/newUI-images/communityView/cancel-booking.png"
                        />
                        Reservation Cancellation Policy
                      </h4>
                      <div>
                        <ul className="rc-policy">
                          <li>
                            If you decide to cancel your reservation 10 or more
                            days before your move-in date, a cancellation fee
                            equivalent to 50% of one month’s rent will be
                            applied.
                          </li>
                          <li>
                            For cancellations made less than 10 days prior to
                            move-in, a fee equal to a full month’s rent will be
                            charged.
                          </li>
                          <li>
                            <b>Please note:</b> Card processing fees are
                            non-refundable regardless of the cancellation date.
                          </li>
                        </ul>
                      </div>

                      <hr />
                      <h4>
                        {" "}
                        <img
                          width={25}
                          className="me-3"
                          src="/assets/newUI-images/communityView/audit.png"
                        />
                        Background Screening & Booking Approval
                      </h4>
                      <ul className="rc-policy ">
                        <li>
                          {" "}
                          All bookings are subject to identity verification and
                          a background screening process. In the event that we
                          must cancel a booking based on the results of these
                          checks, you will receive a complete refund, including
                          all applicable charges.
                        </li>
                      </ul>

                      <hr />

                      <h4 className="d-flex justify-content-between">
                        Getting Around{" "}
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#walkscoreInfoMadal"
                          className="howworks"
                        >
                          How Does It Work?
                        </a>{" "}
                      </h4>

                      <div className="scoreView scorecard">
                        {this.state.walkscore != null && (
                          <div className="item">
                            {" "}
                            <div className="score-icon">
                              <img
                                src="https://suiteam-website.s3.us-west-1.amazonaws.com/new/images/screen-3/walk.svg"
                                width="25px"
                                alt=""
                              />{" "}
                              <span> {this.state.walkscore}</span>
                            </div>
                            <h3>Walk Score</h3>
                            <p>
                              {" "}
                              {this.state.walkscore >= 90
                                ? "Walker's Paradise"
                                : this.state.walkscore >= 70
                                ? "Very Walkable"
                                : this.state.walkscore >= 50
                                ? "Somewhat Walkable"
                                : this.state.walkscore >= 25
                                ? "Car-Dependent"
                                : "Car-Dependent"}
                            </p>
                          </div>
                        )}

                        {this.state.bikescore != null && (
                          <div className="item">
                            {" "}
                            <div className="score-icon">
                              <img
                                src="https://suiteam-website.s3.us-west-1.amazonaws.com/new/images/screen-3/bike.svg"
                                width="50px"
                                alt=""
                              />{" "}
                              <span>{this.state.bikescore}</span>
                            </div>
                            <h3>Bike Score</h3>{" "}
                            <p>
                              {" "}
                              {this.state.bikescore >= 90
                                ? "Biker's Paradise"
                                : this.state.bikescore >= 70
                                ? "Very Bikeable"
                                : this.state.bikescore >= 50
                                ? "Bikeable"
                                : "Somewhat Bikeable"}
                            </p>
                          </div>
                        )}

                        {this.state.transitscore != null && (
                          <div className="item">
                            {" "}
                            <div className="score-icon">
                              <img
                                src="https://suiteam-website.s3.us-west-1.amazonaws.com/new/images/screen-3/bus.svg"
                                width="40px"
                                alt=""
                              />{" "}
                              <span>{this.state.transitscore}</span>
                            </div>
                            <h3>Transit Score</h3>{" "}
                            <p>
                              {" "}
                              {this.state.transitscore >= 90
                                ? "Rider's Paradise"
                                : this.state.transitscore >= 70
                                ? "Excellent Transit"
                                : this.state.transitscore >= 50
                                ? "Good Transit"
                                : this.state.transitscore >= 25
                                ? "Some Transit"
                                : "Minimal Transit"}
                            </p>
                          </div>
                        )}
                      </div>

                      <hr />

                      <h4>Neighborhood</h4>
                      <div className="SAweb_neighbourhood">
                        <ul className="nav nav-tabs p-0">
                          <li>
                            <button
                              className="nav-link active"
                              onClick={this.typeView}
                              id="name"
                              data-toggle="tab"
                              data-target="#commute"
                              type="button"
                              role="tab"
                              aria-controls="commute"
                              aria-selected="false"
                            >
                              Commute
                            </button>
                          </li>
                          {this.state.types.map((row, index) => {
                            return (
                              <li
                                key={index}
                                onClick={() => this.onetype(row, index)}
                              >
                                <button
                                  className="nav-link "
                                  id={row.name}
                                  aria-selected="true"
                                >
                                  {row.name}
                                </button>
                              </li>
                            );
                          })}
                        </ul>

                        <div className="tab-content myTabContentVIew">
                          <div
                            className="tab-pane fade in active"
                            id="commute"
                            role="tabpanel"
                            aria-labelledby="commute-tab"
                          >
                            <div className=" ">
                              {this.state.showlist && !this.state.showSearch ? (
                                <ul className="distanceList">
                                  {finalLocation.map((row, index) => {
                                    return (
                                      <li
                                        className={
                                          this.state.activeNumber == row.name
                                            ? "item test"
                                            : "item"
                                        }
                                        key={index}
                                        onClick={() =>
                                          this.flyToPlace(
                                            row,
                                            index,
                                            "locations"
                                          )
                                        }
                                      >
                                        <p>
                                          {" "}
                                          {row.name} <span>{row.address}</span>{" "}
                                        </p>
                                        <p> {row.distance} mi</p>
                                      </li>
                                    );
                                  })}
                                </ul>
                              ) : (
                                <div className="tabsView">
                                  <h3>What’s My Commute?</h3>
                                  <input
                                    type="text"
                                    id="txtPlaces"
                                    placeholder="Enter a location"
                                    onChange={this.destinationLocation}
                                  />
                                  <div className="view-btns">
                                    <button
                                      type="button"
                                      className="btn black-btn"
                                      onClick={this.handleFormSubmit}
                                    >
                                      Search
                                    </button>
                                    <button
                                      type="button"
                                      className="btn black-btn"
                                      onClick={this.resetData}
                                    >
                                      Reset
                                    </button>
                                  </div>
                                  <div id="dvDistance"></div>
                                </div>
                              )}

                              <div
                                id={
                                  "map" +
                                  this.state.communityObject.community_id
                                }
                                className="map-alignment"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <hr />

                      <h4>Schools</h4>
                      <div className="SAweb_neighbourhood schTabs">
                        <ul className="nav nav-tabs p-0">
                          <li
                            className="nav-item active"
                            id="public"
                            onClick={() => this.handleClick("public")}
                          >
                            <button
                              className="nav-link "
                              id="public2"
                              type="button"
                              aria-selected="true"
                            >
                              Public
                            </button>
                          </li>
                          <li
                            className="nav-item"
                            id="private"
                            onClick={() => this.handleClick("private")}
                          >
                            <button
                              className="nav-link "
                              id="private2"
                              type="button"
                              aria-selected="true"
                            >
                              Private
                            </button>
                          </li>
                          <li
                            className="nav-item"
                            id="charter"
                            onClick={() => this.handleClick("charter")}
                          >
                            <button
                              className="nav-link "
                              id="charter2"
                              type="button"
                              aria-selected="true"
                            >
                              Charter
                            </button>
                          </li>
                          <li className="nav-item" role="presentation">
                            <button className="nav-link splbtn">
                              Data provided by{" "}
                              <a
                                target={"_blank"}
                                href="https://www.greatschools.org/"
                              >
                                {" "}
                                GreatSchools{" "}
                              </a>{" "}
                            </button>
                          </li>
                        </ul>
                        <div className="tab-content myTabContentVIew SAweb_schools">
                          <div
                            className="tab-pane fade in active"
                            id="public"
                            role="tabpanel"
                            aria-labelledby="public-tab"
                          >
                            <section className=" bg-white">
                              {this.state.PageLoader ? (
                                this.state.allScools.length > 0 ? (
                                  <div className="owl-slider pb-5 SAweb_sliderBottomArrows billingSlider">
                                    <div id="carouselSchool">
                                      <OwlCarousel
                                        className="owl-theme owl-carousel"
                                        {...{
                                          loop: false,
                                          margin: 10,
                                          nav: true,
                                          dots: false,
                                          items: 1,
                                          navContainerClass: "owl-buttons",
                                          navText: [
                                            "<i class='glyphicon glyphicon-menu-left'></i>",
                                            "<i class='glyphicon glyphicon-menu-right'></i>",
                                          ],
                                          responsive: {
                                            600: { items: 1, loop: false },
                                            767: { items: 2, loop: false },
                                            992: { items: 2, loop: false },
                                            1199: { items: 2, loop: false },
                                            1600: { items: 3, loop: false },
                                          },
                                        }}
                                      >
                                        {this.state.allScools.map(
                                          (row, index) => {
                                            return (
                                              <div className="item" key={index}>
                                                <div className="caption">
                                                  <p>
                                                    <a
                                                      target="_blank"
                                                      href={row.overviewUrl}
                                                    >
                                                      {row.name}
                                                    </a>
                                                  </p>
                                                  <p className="data">
                                                    {" "}
                                                    <span>
                                                      {row.schoolSummary.substring(
                                                        0,
                                                        213
                                                      )}
                                                      {row.schoolSummary
                                                        .length > 216
                                                        ? "... "
                                                        : ""}
                                                      {row.schoolSummary
                                                        .length > 216 ? (
                                                        <a
                                                          target="_blank"
                                                          href={row.overviewUrl}
                                                        >
                                                          more
                                                        </a>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </span>{" "}
                                                  </p>
                                                  <ul>
                                                    {row.rating != null ? (
                                                      <li>
                                                        {" "}
                                                        <i className="bi bi-star-fill">
                                                          {" "}
                                                        </i>{" "}
                                                        {row.rating}/10{" "}
                                                      </li>
                                                    ) : (
                                                      <li></li>
                                                    )}
                                                    <li>
                                                      {" "}
                                                      <i className="bi bi-telephone">
                                                        {" "}
                                                      </i>{" "}
                                                      {row.phone}
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            );
                                          }
                                        )}
                                      </OwlCarousel>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="no_data_found">
                                    No Data Found!
                                  </div>
                                )
                              ) : (
                                ""
                              )}
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 text-end">
                      <div className="bookingViewSticky">
                        <h3 className="text-center mb-4">Booking Details</h3>
                        <ul className="dates">
                          <li>
                            {" "}
                            <span>Check In</span>
                            <p>
                              {this.state.checkin
                                ? moment(this.state.checkin).format(
                                    "MMMM D, YYYY"
                                  )
                                : ""}
                            </p>
                          </li>
                          <li>
                            {" "}
                            <span>Check Out</span>
                            <p>
                              {this.state.checkout
                                ? moment(this.state.checkout).format(
                                    "MMMM D, YYYY"
                                  )
                                : ""}
                            </p>
                          </li>
                        </ul>

                        <div className="pricingSwitch">
                          <button
                            className={`btn black-btn my-4 ${
                              !this.state.showTotalStay ? "active" : ""
                            }`}
                            onClick={() => this.monthlyCalculation()}
                          >
                            Monthly Cost
                          </button>
                          <button
                            className={`btn black-btn my-4 ${
                              this.state.showTotalStay ? "active" : ""
                            }`}
                            onClick={() => this.totalStayCalculation()}
                          >
                            Total Cost
                          </button>
                        </div>

                        {this.state.showTotalStay ? (
                          <h4> Total Stay Pricing Breakdown</h4>
                        ) : (
                          <h4>Monthly Pricing Breakdown</h4>
                        )}

                        {/* <label className="switch">
                            <input type="checkbox" />
                            <span
                              className="slider round"
                              onClick={() => this.totalStayCalculation()}
                            ></span>
                          </label> */}

                        <hr />
                        <p>
                          {this.state.showTotalStay
                            ? "Total Rent"
                            : " Monthly Rent"}{" "}
                          <span>
                            ${Number(this.state.monthlyRent).toFixed(2)}
                          </span>{" "}
                        </p>
                        <p>
                          <span>
                            Utilities
                            <Tooltip title="Water, Trash, Power and Internet">
                              <i className="bi bi-info-circle cursor-pointer pl-2"></i>
                            </Tooltip>
                          </span>
                          <span>${this.state.utilities}</span>{" "}
                        </p>
                        <p>
                          Housewares & Linens Fee
                          <span>${this.state.housewares}</span>{" "}
                        </p>
                        <p>
                          Service fee <span>${this.state.serviceFee} </span>{" "}
                        </p>
                        {this.state.showTotalStay && (
                          <p>
                            <span>
                              {" "}
                              Move Out Cleaning Fee (One time)
                              <Tooltip title="This is a one time cleaning fee that will be charged closer to check out date">
                                <i className="bi bi-info-circle cursor-pointer pl-2"></i>
                              </Tooltip>
                            </span>
                            <span>${this.state.cleaning}</span>{" "}
                          </p>
                        )}
                        <hr />
                        <h2>
                          {this.state.showTotalStay ? "Total" : "Monthly Total"}{" "}
                          <span>${this.state.totalAmount}</span>{" "}
                        </h2>
                        {!this.state.showTotalStay && (
                          <p>
                            <span>
                              {" "}
                              Move Out Cleaning Fee (One time)
                              <Tooltip title="This is a one time cleaning fee that will be charged closer to check out date">
                                <i className="bi bi-info-circle cursor-pointer pl-2"></i>
                              </Tooltip>
                            </span>
                            <span>${this.state.cleaning}</span>{" "}
                          </p>
                        )}
                        <p
                          style={{
                            color: "red",
                            fontSize: "16px",
                            justifyContent: "center",
                          }}
                        >
                          {this.state.errorMessage}
                        </p>
                        {this.state.buttonLoader ? (
                          <span
                            style={{
                              fontSize: 20,
                              textAlign: "center",
                              display: "block",
                            }}
                          >
                            <i className="fa fa-spinner fa-spin" /> please wait
                            ...!
                          </span>
                        ) : (
                          <button
                            type="button"
                            className="btn black-btn mt-4"
                            onClick={this.handleClick2}
                          >
                            Book Now
                          </button>
                        )}

                        <div className="paymentSchedule ">
                          <div className="divider"></div>
                          <h4>Payment Schedule</h4>
                          <hr />
                          {this.state?.invoiceList?.length > 0 ? (
                            this.state.newInvoiceList.map((data, index) => {
                              const isLastItem =
                                index === this.state.newInvoiceList.length - 1;
                              const lastItem =
                                this.state.newInvoiceList[
                                  this.state.newInvoiceList.length - 1
                                ];

                              // const from = moment(data.InvoiceFromDate).format(
                              //   "MMM DD"
                              // );
                              // const to = moment(data.InvoiceToDate).format(
                              //   "MMM DD"
                              // );
                              return (
                                <React.Fragment key={index}>
                                  <p>
                                    <span>
                                      <span>
                                        {" "}
                                        {data.from} - {data.to}{" "}
                                      </span>
                                      <span>
                                        ${data.InvoiceAmount.toFixed(2)}
                                      </span>
                                    </span>

                                    <span className="lightclr">
                                      {" "}
                                      {data.InvoiceNote}
                                    </span>
                                  </p>

                                  {isLastItem && (
                                    <p>
                                      <span>
                                        <span>
                                          {" "}
                                          Move Out Cleaning Fee (One time)
                                        </span>
                                        <span>${this.state.cleaning}</span>
                                      </span>

                                      <span className="lightclr">
                                        {lastItem.totalDays <= 30 ? (
                                          "Due On Booking"
                                        ) : (
                                          <>
                                            Due{" "}
                                            {moment(lastItem.from)
                                              .subtract(7, "days")
                                              .format("MMM DD")}
                                          </>
                                        )}
                                      </span>
                                    </p>
                                  )}
                                </React.Fragment>
                              );
                            })
                          ) : (
                            <p> No invoice data available</p>
                          )}
                          {/* <p>
                            May 01 -May 31
                            <span className="lightclr">Due on Booking</span>
                            <span>$0000.00</span>
                          </p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="modal fade SAweb_modalPoup"
                  id="staticBackdrop"
                  data-backdrop="static"
                  data-keyboard="false"
                  tabIndex="-1"
                  aria-labelledby="staticBackdropLabel"
                  role="dialog"
                >
                  <div className="modal-dialog modal-lg-SAweb  modal-dialog-scrollable modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header border-0">
                        <button
                          type="button"
                          className="btn close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          {" "}
                          <i className="bi bi-x"></i>{" "}
                        </button>
                      </div>
                      <div className="modal-body border-0 mb-5">
                        <div className="SAweb_amenities ">
                          <ul className="nav nav-tabs">
                            <li className="active">
                              <a data-toggle="tab" href="#tab1">
                                Property Amenities
                              </a>
                            </li>
                            <li>
                              <a data-toggle="tab" href="#tab2">
                                In-Unit Amenities
                              </a>
                            </li>
                          </ul>

                          <div className="tab-content">
                            <div id="tab1" className="tab-pane fade in active">
                              <div className="box">
                                {this.state.communityAmenities.map(
                                  (row, index) => {
                                    return (
                                      <div className="item" key={index}>
                                        <img
                                          src={
                                            s3BucketUrl +
                                            "Amenities/" +
                                            row.aparment_amenity_name.replace(
                                              /[^A-Z0-9]+/gi,
                                              ""
                                            ) +
                                            ".png"
                                          }
                                          width="55px"
                                          alt=""
                                        />
                                        <span>{row.aparment_amenity_name}</span>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                            <div id="tab2" className="tab-pane fade">
                              <div className="box">
                                {this.state.appartmentAmenities.map(
                                  (row, index) => {
                                    return (
                                      <div className="item" key={index}>
                                        <img
                                          src={
                                            s3BucketUrl +
                                            "Amenities/" +
                                            row.aparment_amenity_name.replace(
                                              /[^A-Z0-9]+/gi,
                                              ""
                                            ) +
                                            ".png"
                                          }
                                          width="55px"
                                          alt=""
                                        />
                                        <span>{row.aparment_amenity_name}</span>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* <section>
              <div className="SAweb_neighbourhood py-5">
                <div className="  ">
                  <div className="container-fluid">
                    <h4>Neighborhood</h4>
                    <ul className="nav nav-tabs mt-5">
                      <li>
                        <button
                          className="nav-link active"
                          onClick={this.typeView}
                          id="name"
                          data-toggle="tab"
                          data-target="#commute"
                          type="button"
                          role="tab"
                          aria-controls="commute"
                          aria-selected="false"
                        >
                          Commute
                        </button>
                      </li>
                      {this.state.types.map((row, index) => {
                        return (
                          <li
                            key={index}
                            onClick={() => this.onetype(row, index)}
                          >
                            <button
                              className="nav-link "
                              id={row.name}
                              aria-selected="true"
                            >
                              {row.name}
                            </button>
                          </li>
                        );
                      })}
                    </ul>
                  </div>

                  <div className="tab-content myTabContentVIew">
                    <div
                      className="tab-pane fade in active"
                      id="commute"
                      role="tabpanel"
                      aria-labelledby="commute-tab"
                    >
                      <div className="sm-d-flex ">
                        <div className="col-sm-6">
                          {this.state.showlist && !this.state.showSearch ? (
                            <div className="tabsView">
                              <ul className="distanceList">
                                {finalLocation.map((row, index) => {
                                  return (
                                    <li
                                      className={
                                        this.state.activeNumber == row.name
                                          ? "item test"
                                          : "item"
                                      }
                                      key={index}
                                      onClick={() =>
                                        this.flyToPlace(row, index, "locations")
                                      }
                                    >
                                      <p>
                                        {" "}
                                        {row.name} <span>{row.address}</span>{" "}
                                      </p>
                                      <p> {row.distance} mi</p>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          ) : (
                            <div className="tabsView">
                              <h3>What’s My Commute?</h3>
                              <input
                                type="text"
                                id="txtPlaces"
                                placeholder="Enter a location"
                                onChange={this.destinationLocation}
                              />
                              <div className="view-btns">
                                <button
                                  type="button"
                                  className="btn black-btn"
                                  onClick={this.handleFormSubmit}
                                >
                                  Search
                                </button>
                                <button
                                  type="button"
                                  className="btn black-btn"
                                  onClick={this.resetData}
                                >
                                  Reset
                                </button>
                              </div>
                              <div id="dvDistance"></div>
                            </div>
                          )}
                        </div>
                        <div className="col-sm-6">
                          <div
                            id={"map" + this.state.communityObject.community_id}
                            className="map-alignment"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}

            {/* <section className="SAweb_scoreView">
              <div>
                <h3>Getting Around</h3>{" "}
                <a
                  href="#"
                  data-toggle="modal"
                  data-target="#walkscoreInfoMadal"
                  className="howworks"
                >
                  {" "}
                  How Does It Work?{" "}
                </a>
              </div>
              <div className="box mb-5">
                {this.state.walkscore == null ? (
                  ""
                ) : (
                  <div className="item">
                    <div className="wlakScoreView">
                      <div className="score_view">
                        <div className="pic">
                          <img
                            src="https://suiteam-website.s3.us-west-1.amazonaws.com/new/images/screen-3/walk.svg"
                            alt=""
                            width="20px"
                          />
                        </div>

                        <Progress
                          type="circle"
                          percent={this.state.walkscore}
                          format={(percent) => `${percent}`}
                        />
                      </div>
                      <p>Walk Score</p>
                    </div>
                  </div>
                )}

                {this.state.bikescore == null ? (
                  ""
                ) : (
                  <div className="item">
                    <div className="wlakScoreView">
                      <div className="score_view">
                        <div className="pic">
                          <img
                            src="https://suiteam-website.s3.us-west-1.amazonaws.com/new/images/screen-3/bike.svg"
                            alt=""
                            width="40px"
                          />
                        </div>
                        <Progress
                          type="circle"
                          percent={this.state.bikescore}
                          format={(percent) => `${percent}`}
                        />
                      </div>{" "}
                      <p>Bike Score</p>
                    </div>
                  </div>
                )}
                {this.state.transitscore == null ? (
                  ""
                ) : (
                  <div className="item">
                    <div className="wlakScoreView">
                      <div className="score_view">
                        <div className="pic">
                          <img
                            src="https://suiteam-website.s3.us-west-1.amazonaws.com/new/images/screen-3/bus.svg"
                            alt=""
                            width="30px"
                          />
                        </div>
                        <Progress
                          type="circle"
                          percent={this.state.transitscore}
                          format={(percent) => `${percent}`}
                        />
                      </div>
                      <p>Transit Score</p>
                    </div>
                  </div>
                )}
              </div>
            </section> */}

            {/* <section className="SAweb_schools second border-top border-2 border-dark">
              <div className="SAweb_location bg-white ">
                <div className="container">
                  <div className="row   mx-0">
                    <div className="col-sm-1 ">
                      <div className="HeadingRotate">
                        <h2 className="h2_rotate">Schools</h2>
                      </div>
                    </div>
                    <div className="col-sm-11 py-5">
                      <ul className="nav nav-tabs">
                        <li
                          className="nav-item active"
                          id="public"
                          onClick={() => this.handleClick("public")}
                        >
                          <button
                            className="nav-link "
                            type="button"
                            aria-selected="true"
                          >
                            Public
                          </button>
                        </li>
                        <li
                          className="nav-item"
                          id="private"
                          onClick={() => this.handleClick("private")}
                        >
                          <button
                            className="nav-link "
                            type="button"
                            aria-selected="true"
                          >
                            Private
                          </button>
                        </li>
                        <li
                          className="nav-item"
                          id="charter"
                          onClick={() => this.handleClick("charter")}
                        >
                          <button
                            className="nav-link "
                            type="button"
                            aria-selected="true"
                          >
                            Charter
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button className="nav-link splbtn">
                            Data provided by{" "}
                            <a
                              target={"_blank"}
                              href="https://www.greatschools.org/"
                            >
                              {" "}
                              GreatSchools{" "}
                            </a>{" "}
                          </button>
                        </li>
                      </ul>
                      <div className="tab-content myTabContentVIew">
                        <div
                          className="tab-pane fade in active"
                          id="public"
                          role="tabpanel"
                          aria-labelledby="public-tab"
                        >
                          <section className=" bg-white pt-5">
                            {this.state.PageLoader ? (
                              this.state.allScools.length > 0 ? (
                                <div className="owl-slider pb-5 SAweb_sliderBottomArrows billingSlider">
                                  <div id="carouselSchool">
                                    <OwlCarousel
                                      className="owl-theme owl-carousel"
                                      {...{
                                        loop: false,
                                        margin: 10,
                                        nav: true,
                                        dots: false,
                                        items: 1,
                                        navContainerClass: "owl-buttons",
                                        navText: [
                                          "<i class='glyphicon glyphicon-menu-left'></i>",
                                          "<i class='glyphicon glyphicon-menu-right'></i>",
                                        ],
                                        responsive: {
                                          600: { items: 1, loop: false },
                                          767: { items: 2, loop: false },
                                          992: { items: 3, loop: false },
                                          1199: { items: 3, loop: false },
                                        },
                                      }}
                                    >
                                      {this.state.allScools.map(
                                        (row, index) => {
                                          return (
                                            <div className="item" key={index}>
                                              <div className="caption">
                                                <p>
                                                  <a
                                                    target="_blank"
                                                    href={row.overviewUrl}
                                                  >
                                                    {row.name}
                                                  </a>
                                                </p>
                                                <p>
                                                  {" "}
                                                  <span>
                                                    {row.schoolSummary.substring(
                                                      0,
                                                      213
                                                    )}
                                                    {row.schoolSummary.length >
                                                    216
                                                      ? "... "
                                                      : ""}
                                                    {row.schoolSummary.length >
                                                    216 ? (
                                                      <a
                                                        target="_blank"
                                                        href={row.overviewUrl}
                                                      >
                                                        more
                                                      </a>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </span>{" "}
                                                </p>
                                                <ul>
                                                  {row.rating != null ? (
                                                    <li>
                                                      {" "}
                                                      <i className="bi bi-star-fill">
                                                        {" "}
                                                      </i>{" "}
                                                      {row.rating}/10{" "}
                                                    </li>
                                                  ) : (
                                                    <li></li>
                                                  )}
                                                  <li>
                                                    {" "}
                                                    <i className="bi bi-telephone">
                                                      {" "}
                                                    </i>{" "}
                                                    {row.phone}
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                    </OwlCarousel>
                                  </div>
                                </div>
                              ) : (
                                <div className="no_data_found">
                                  No Data Found!
                                </div>
                              )
                            ) : (
                              ""
                            )}
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}
          </div>
        )}
        <RequestCallback />
        <div
          id="smallmodel-Carousel1"
          className=" modal fade SAweb_modalPoup Saweb_MorePhotosPopup "
          role="dialog"
          data-backdrop="static"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered modal-lg-2">
            <div className="modal-content notification-popup borderRadius">
              <div className="modal-header border-0">
                <button
                  type="button"
                  className="btn close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  {" "}
                  <i className="bi bi-x"></i>{" "}
                </button>
              </div>
              <div className="">
                {communityALLImages.length > 0 && !this.state.imgloader ? (
                  <div className="">''</div>
                ) : (
                  <div className="Saweb_MorePhotosSlider">
                    <OwlCarousel
                      className="owl-theme owl-carousel"
                      {...{
                        loop: false,
                        nav: true,
                        dots: true,
                        items: 1,
                        navContainerClass: "owl-buttons",
                        navText: [
                          "<i class='glyphicon glyphicon-menu-left'></i>",
                          "<i class='glyphicon glyphicon-menu-right'></i>",
                        ],
                        responsive: {
                          600: { items: 1, nav: true, loop: false },
                          767: { items: 1, nav: true, loop: false },
                          992: { items: 1, nav: true, loop: false },
                          1199: { items: 1, nav: true, loop: false },
                        },
                      }}
                    >
                      {communityALLImages.map((row, index) => {
                        return (
                          <div className="item" key={index}>
                            <img
                              className="img-responsive"
                              src={row.image_name}
                              alt={row}
                            />
                          </div>
                        );
                      })}
                    </OwlCarousel>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <FullPopup fullpopdata={this.state.fullpopdata} />

        <div
          id="walkscoreInfoMadal"
          className="modal fade SAweb_modalPoup"
          role="dialog"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header border-0">
                <button
                  type="button"
                  className="btn close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="bi bi-x"></i>{" "}
                </button>
              </div>
              <div className="">
                <div className="modal-body">
                  <div className="all-score-table">
                    <table width="100%">
                      <thead>
                        <tr>
                          <th width="30%">Transit Score</th>
                          <th width="70%">Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <b>90–100</b>
                          </td>
                          <td>
                            <b>Rider's Paradise</b>
                            <span>World-class public transportation.</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>70–89</b>
                          </td>
                          <td>
                            <b>Excellent Transit</b>
                            <span>Transit is convenient for most trips.</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>50–69</b>
                          </td>
                          <td>
                            <b>Good Transit</b>
                            <span>
                              Many nearby public transportation options.
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>25–49</b>
                          </td>
                          <td>
                            <b>Some Transit</b>
                            <span>
                              A few nearby public transportation options.
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>0-24</b>
                          </td>
                          <td>
                            <b>Minimal Transit</b>
                            <span>It is possible to get on a bus.</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table width="100%">
                      <thead>
                        <tr>
                          <th width="30%">Walk Score</th>
                          <th width="70%">Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <b>90–100</b>
                          </td>
                          <td>
                            <b>Walker's Paradise</b>
                            <span>Daily errands do not require a car.</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>70–89</b>
                          </td>
                          <td>
                            <b>Very Walkable</b>
                            <span>
                              Most errands can be accomplished on foot.
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>50–69</b>
                          </td>
                          <td>
                            <b>Somewhat Walkable</b>
                            <span>
                              Some errands can be accomplished on foot.
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>25–49</b>
                          </td>
                          <td>
                            <b>Car-Dependent</b>
                            <span>Most errands require a car.</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>0–24</b>
                          </td>
                          <td>
                            <b>Car-Dependent</b>
                            <span>Almost all errands require a car.</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table width="100%">
                      <thead>
                        <tr>
                          <th width="30%">Bike Score</th>
                          <th width="70%">Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <b>90–100</b>
                          </td>
                          <td>
                            <b>Biker's Paradise</b>
                            <span>
                              Daily errands can be accomplished on a bike.
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>70–89</b>
                          </td>
                          <td>
                            <b>Very Bikeable</b>
                            <span>Biking is convenient for most trips.</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>50–69</b>
                          </td>
                          <td>
                            <b>Bikeable</b>
                            <span>Some bike infrastructure.</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>0–49</b>
                          </td>
                          <td>
                            <b>Somewhat Bikeable</b>
                            <span>Minimal bike infrastructure.</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default LocationPropertyDetails;
